export interface Bonus {
  number: string
  title: string
  body: string
  volume: string
  image: string
  alt: string
}

export const bonuses: Bonus[] = [
  {
    number: 'Bonus 1',
    title: 'Démarrage rapide : votre premier parcours CAP™ en 14 jours',
    body: 'Pour ne pas vous perdre dans six tomes : un plan de quatorze jours qui indique quoi lire en priorité et quoi mettre en place, jusqu’à votre premier parcours structuré. Avec la fiche pour préparer chaque séance en dix minutes.',
    volume: '≈ 14 pages',
    image:
      'https://cdn.magicpatterns.com/uploads/px5zDKTxnKCWjj5n3HpW3S/Bonus--1.png',
    alt: 'Livret imprimé Bonus 01 Démarrage rapide, posé près d’une fiche calendrier de quatorze jours',
  },
  {
    number: 'Bonus 2',
    title: 'Le Carnet du coaché',
    body: 'Un carnet prêt à imprimer à remettre à chacun de vos clients : leur point de départ, leur feuille de route, leur Journal des ancrages et leurs trois bilans, pour qu’ils constatent eux-mêmes le chemin parcouru.',
    volume: '≈ 24 pages, 9 fiches',
    image:
      'https://cdn.magicpatterns.com/uploads/dqktyaNFVSPnMfmYjs5Xcz/Bonus--2.png',
    alt: 'Le Carnet du coaché imprimé, ouvert sur la feuille de route en trois phases et le Journal des ancrages',
  },
  {
    number: 'Bonus 3',
    title: 'La Séance Zéro, prête à l’emploi',
    body: 'Le déroulé de 75 minutes sur une seule page, une version courte de 45 minutes, trente questions CORE classées et deux e-mails à envoyer avant et après.',
    volume: '≈ 12 pages',
    image:
      'https://cdn.magicpatterns.com/uploads/9woGg7QMnxEpGLv5uQPQGY/Bonus--3.png',
    alt: 'Livret Bonus 03 La Séance Zéro prête à l’emploi et sa fiche de déroulé minuté sur 75 minutes',
  },
  {
    number: 'Bonus 4',
    title: 'Le Coffre des preuves de progrès',
    body: 'Les progrès qu’on ne nomme pas s’oublient. Sept types de progrès pour les repérer, vingt phrases pour aider vos clients à les formuler, et trois fiches pour les conserver tout au long du parcours.',
    volume: '≈ 12 pages',
    image:
      'https://cdn.magicpatterns.com/uploads/w8dxijqwUUk2YPbdr3MP2M/Bonus--4.png',
    alt: 'Le Coffre des preuves de progrès ouvert, avec ses fiches imprimées « Preuve de progrès »',
  },
  {
    number: 'Bonus 5',
    title: 'Le client qui stagne : la fiche d’urgence en 15 minutes',
    body: 'Trois questions pour identifier le type de blocage, un arbre de décision sur une page et cinq trames pour ajuster, sans forcer le client et en restant dans votre cadre.',
    volume: '≈ 14 pages',
    image:
      'https://cdn.magicpatterns.com/uploads/5DUjkNY4yvby9tYf1Envf4/Bonus--5.png',
    alt: 'Livret Bonus 05 Le client qui stagne et sa fiche d’arbre de décision',
  },
]
